import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { APP_CONFIG, AppConfig } from '@/app-config.module';

@Injectable({
  providedIn: 'root'
})
export class SMSService {
	endpoint: string = 'sms'

  constructor(
		private http: HttpClient,
		@Inject(APP_CONFIG) private config: AppConfig
	) { }

	private handleError(error: any, context: any = '') {
		console.error('Invalid Request')

		let message = `Failure: ${error}`;

		// if( context ) {
		// 	message = `${message} ${context}`;
		// }

		// return an observable with a user-facing error message
		return throwError(message);
	}

	public sendSMS( smsData: any ){
		const url = `${ this.config.apiUrl }/${ this.endpoint }/send`

		return this.http.post( url, smsData )
			.pipe(
				catchError(error => this.handleError(error, 'Check your submisision and try again.') )
			);
	}
}
